export default () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.5 15.0859C9.5 15.9768 8.42286 16.423 7.79289 15.793L5.20711 13.2072C4.81658 12.8167 4.81658 12.1835 5.20711 11.793L7.7929 9.2072C8.42286 8.57724 9.5 9.02341 9.5 9.91431L9.5 15.0859Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 12.5C20 12.2239 19.7761 12 19.5 12H9.5V13H19.5C19.7761 13 20 12.7761 20 12.5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.5 12.5C20.5 11.9477 20.0523 11.5 19.5 11.5H9V13.5H19.5C20.0523 13.5 20.5 13.0523 20.5 12.5Z"
      fill="currentColor"
    />
  </svg>
);
